import React from 'react';
import StartupCard from './StartupCard';

const StartupGrid = ({ startups, visibleCount, onVoteChange }) => {
  const visibleStartups = startups.slice(0, visibleCount);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-6 gap-5">
      {visibleStartups.map((startup) => (
        <StartupCard 
          key={startup.id} 
          startup={startup} 
          onVoteChange={onVoteChange}
        />
      ))}
    </div>
  );
};

export default StartupGrid;
